import {
    styled,
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Chip,
    Button,
    Typography
} from '@mui/material';
import color from 'src/theme/color';

export const ButtonIconBox = styled(Box)<{ $isHovered: boolean }>(
    ({ $isHovered }) => ({
        marginLeft: '8px',
        opacity: $isHovered ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out',
        display: 'flex',
        alignItems: 'center',
        position: 'absolute',
        right: 'calc(50% - 46px)'
    })
);

export const StyledDivider = styled('div')({
    marginTop: '8px',
    marginBottom: '6px',
    backgroundColor: color.grey2,
    height: '0.5px'
});

export const StyledDialog = styled(Dialog)({
    '& .MuiPaper-root': {
        backgroundColor: color.darkBlue,
        color: color.white,
        borderRadius: '12px'
    }
});

export const StyledDialogTitle = styled(DialogTitle)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderBottom: `1px solid ${color.greyTransparent}`,
    padding: '16px 24px',
    alignContent: 'center'
});

export const StyledDialogContent = styled(DialogContent)({
    padding: '24px'
});

export const StyledDialogActions = styled(DialogActions)({
    padding: '16px 24px',
    borderTop: `1px solid ${color.greyTransparent}`,
    justifyContent: 'space-between'
});

export const SearchTextField = styled(TextField)({
    marginBottom: '24px',
    '& .MuiOutlinedInput-root': {
        color: color.white,
        backgroundColor: color.greyTransparent,
        borderRadius: '8px',
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'transparent'
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: color.yellowTransparent
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: color.yellowTransparent2,
            borderWidth: '1px'
        }
    }
});

export const SelectedSkillsContainer = styled(Box)({
    marginBottom: '24px'
});

export const SkillsContainer = styled(Box)({
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px'
});

export const SelectedSkillChip = styled(Chip)({
    backgroundColor: color.yellowTransparent1,
    color: color.white,
    '& .MuiChip-deleteIcon': {
        color: color.yellowTransparent2,
        '&:hover': {
            color: color.yellow
        }
    }
});

export const SuggestedSkillChip = styled(Chip)({
    backgroundColor: color.greyTransparent,
    color: color.white80,
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: color.yellowTransparent,
        color: color.yellow
    }
});

export const NoSkillsFoundContainer = styled(Box)({
    textAlign: 'center',
    paddingTop: '16px',
    paddingBottom: '16px'
});

export const ClearSearchButton = styled(Button)({
    color: color.yellow,
    marginTop: '8px',
    '&:hover': {
        backgroundColor: 'transparent'
    }
});

export const SectionTitle = styled(Typography)({
    marginBottom: '8px',
    color: color.grey
});
